import { Container, FlexContainer, LineSeparator } from '@news12/storybook-news'
import { parse as parser } from '@news12/transformer'

import React, { useMemo } from 'react'

import useDynamicScripts from '../../hooks/useDynamicScripts'
import { structure } from '../../styles/global'
import BaseCSS from '../../styles/global/BaseCSS'
import style, { hideLayout } from '../../styles/pages/static'
import AdUnit from '../Ads/AdUnit'
import Metadata from '../Metadata'
import UnresetCSS from '../UnresetCSS'
import renderHtml, { sanitizedHtml } from '../utilities/renderHTML'

import Head from 'next/head'

const StaticPage = ({ data }) => {
  const html = parser(data?.[0]?.fields?.body, false)
  useDynamicScripts({ html, scripts: ['facebook-embed', 'tagboard-embed', 'twitter-embed'] })

  const metadata = {
    title: data?.[0]?.fields?.title,
    description: data?.[0]?.fields?.description
  }
  const withAds = data?.[0]?.fields?.withAds || true

  const sidebarAdUnitSizes = {
    height: 'auto',
    minHeight: '250px'
  }

  return (
    <>
      <Head>
        <title>{data?.[0]?.fields?.title || 'News 12'}</title>
        <base target='_blank' />
      </Head>
      <Metadata metadata={metadata} />
      <div className='main-layout-container'>
        <div className='static-page-container main-layout'>
          {withAds && (
            <>
              <FlexContainer justifyContent='center'>
                <AdUnit adUnitTemplate='leaderboard' id='ad-banner-top' type='leaderboardRedesign' />
              </FlexContainer>
              <Container>
                <LineSeparator margin={['2.25rem auto', '2.5rem auto']} />
              </Container>
            </>
          )}
          <h1>{data?.[0]?.fields?.title}</h1>
          {renderHtml(sanitizedHtml(html))}
        </div>
        {withAds && (
          <Container className='main-layout-sidebar'>
            <AdUnit
              adUnitTemplate='rectangleVertical'
              adUnitSizes={sidebarAdUnitSizes}
              id='ad-banner-sidebar-top'
              type='sidebar1'
            />
          </Container>
        )}
        <style jsx global>
          {style}
        </style>
        <style jsx global>
          {structure}
        </style>
        <style jsx global>{`${data?.[0]?.fields?.hideLayout && hideLayout}`}</style>
        <UnresetCSS />
        <BaseCSS />
      </div>
    </>
  )
}

export default StaticPage
